import { useGetUserHoldingLimitsQuery } from 'src/shared/api/holding';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { Alert, AlertButton } from './styles';
import { useHistory } from 'react-router';
import getNumericBalance from 'src/shared/utils/getNumericBalance';
import { useIsHeroAdmin } from 'src/shared/hooks/useIsHeroAdmin';

export const BalanceAlert = () => {
  const { t } = useTranslation(['overview', 'common']);
  const { isHeroAdmin } = useIsHeroAdmin();
  const { data: userHoldingLimits } = useGetUserHoldingLimitsQuery();
  const history = useHistory();
  const redirectToSaldoPage = () => {
    history.push('/saldo');
  };
  if (!isHeroAdmin || !userHoldingLimits) {
    return null;
  }

  if (userHoldingLimits.holding.availableAmount < 1) {
    return (
      <Alert severity="warning" sx={{ background: '#FDEDDE' }}>
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(t('limit alert'))
          }}
        ></span>
      </Alert>
    );
  }

  const companies = userHoldingLimits?.companies || [];
  if (companies.length === 0) {
    return null;
  }

  const companiesBellowThreshold = companies.filter(el => {
    const numericBalance = getNumericBalance(el.balance);
    return numericBalance >= 1 && numericBalance <= el.lowOnFundsThreshold;
  });
  const companiesEmptyBalance = companies.filter(el => getNumericBalance(el.balance) < 1);

  if (companiesEmptyBalance.length > 0 && companiesBellowThreshold.length > 0) {
    return (
      <Alert severity="error" sx={{ background: '#FAE2E2' }}>
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(t('self funding.alert mixedEmptyAndBellowThreshold'))
          }}
        ></span>
        <AlertButton variant={'contained'} color="error" onClick={redirectToSaldoPage}>
          {t('self funding.review')}
        </AlertButton>
      </Alert>
    );
  }

  if (companiesBellowThreshold.length === 1) {
    return (
      <Alert severity="warning" sx={{ background: '#FDEDDE' }}>
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              t('self funding.alert oneBellowThreshold', { companyName: companiesBellowThreshold[0].name })
            )
          }}
        ></span>
        <AlertButton variant={'contained'} color="warningAlert" onClick={redirectToSaldoPage}>
          {t('self funding.recharge balance')}
        </AlertButton>
      </Alert>
    );
  }

  if (companiesEmptyBalance.length === 1) {
    return (
      <Alert severity="error" sx={{ background: '#FAE2E2' }}>
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(t('self funding.alert oneEmpty', { companyName: companiesEmptyBalance[0].name }))
          }}
        ></span>
        <AlertButton variant={'contained'} color="error" onClick={redirectToSaldoPage}>
          {t('self funding.recharge balance')}
        </AlertButton>
      </Alert>
    );
  }

  if (companiesBellowThreshold.length > 0 && companiesEmptyBalance.length === 0) {
    return (
      <Alert severity="warning" sx={{ background: '#FDEDDE' }}>
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(t('self funding.alert someBellowThreshold'))
          }}
        ></span>
        <AlertButton variant={'contained'} color="warningAlert" onClick={redirectToSaldoPage}>
          {t('self funding.review')}
        </AlertButton>
      </Alert>
    );
  }

  if (companiesEmptyBalance.length > 0 && companiesBellowThreshold.length === 0) {
    return (
      <Alert severity="error" sx={{ background: '#FAE2E2' }}>
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(t('self funding.alert someEmpty'))
          }}
        ></span>
        <AlertButton variant={'contained'} color="error" onClick={redirectToSaldoPage}>
          {t('self funding.review')}
        </AlertButton>
      </Alert>
    );
  }

  console.error('UNEXPECTED CASE', userHoldingLimits);
  return null;
};
